import { render, staticRenderFns } from "./RevisionStep.vue?vue&type=template&id=c5f196fc"
import script from "./RevisionStep.vue?vue&type=script&lang=ts&setup=true"
export * from "./RevisionStep.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports